import { createContext } from "react";
const GuestHouseMasterContext = createContext({});

export default GuestHouseMasterContext;
